(() => {
  const dialog = document.getElementById('mm-accessibility');
  if (!dialog) return;
  const root = document.documentElement;
  const defaults = {text: 100, contrast: false, links: false, motion: false};
  let preferences = {...defaults};
  try {
    const saved = JSON.parse(localStorage.getItem('meme-accessibility') || '{}');
    preferences.text = [100, 125, 150, 175, 200].includes(saved.text) ? saved.text : 100;
    for (const key of ['contrast', 'links', 'motion']) preferences[key] = saved[key] === true;
  } catch (_) {}
  const status = dialog.querySelector('[data-accessibility-status]');
  function apply(announce = false) {
    root.style.fontSize = `${preferences.text}%`;
    root.classList.toggle('mm-large-text', preferences.text >= 150);
    root.classList.toggle('mm-high-contrast', preferences.contrast);
    root.classList.toggle('mm-link-underlines', preferences.links);
    root.classList.toggle('mm-reduce-motion', preferences.motion);
    dialog.querySelector('[data-text-size]').value = String(preferences.text);
    for (const key of ['contrast', 'links', 'motion']) dialog.querySelector(`[data-setting="${key}"]`).checked = preferences[key];
    if (announce) status.textContent = dialog.dataset.savedLabel;
  }
  function save() {
    try { localStorage.setItem('meme-accessibility', JSON.stringify(preferences)); } catch (_) {}
    apply(true);
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-accessibility-open]')) {
      dialog.showModal();
      status.textContent = '';
    }
  });
  dialog.querySelector('[data-accessibility-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-text-size]').addEventListener('change', event => {
    preferences.text = Number(event.target.value); save();
  });
  dialog.querySelectorAll('[data-setting]').forEach(input => input.addEventListener('change', () => {
    preferences[input.dataset.setting] = input.checked; save();
  }));
  dialog.querySelector('[data-accessibility-reset]').addEventListener('click', () => {
    preferences = {...defaults}; save();
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  apply();
})();
